export type Role = "admin" | "professional" | "client";

/** Runtime guard for narrowing an untrusted string (e.g. `users.role`, typed
 *  `string` in the generated DB types) to the canonical `Role` union — use
 *  instead of an `as Role` cast so an out-of-enum value can't silently flow
 *  through as a valid role. */
export function isRole(value: unknown): value is Role {
  return value === "admin" || value === "professional" || value === "client";
}

export const ROLE_DASHBOARD: Record<Role, string> = {
  admin:        "/admin",
  professional: "/pro/dashboard",
  client:       "/dashboard",
};

export const ROLE_LABEL: Record<Role, string> = {
  admin:        "Admin",
  professional: "Pro Dashboard",
  client:       "Dashboard",
};
